<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="content-wrapper">
    <div class="col-12">
        <mat-card class="example-card">
            <mat-card-title>ปริมาณอ้อยเข้าหีบ {{ year_n[2] }}</mat-card-title>
            <mat-card-content>
                <div class="row justify-content-md-center">
                    <div class="col-md-auto">
                        <ul class="nav nav-pills ml-auto p-2">
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary active" href="#tab_1" (click)="change_tap23(0)"
                                    data-toggle="tab">ยอดอ้อยรายโซน</a>
                            </li>
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary" href="#tab_2" (click)="change_tap23(1)"
                                    data-toggle="tab">ยอดอ้อยตามกลุ่มในโซน</a>
                            </li>
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary" href="#tab_2" (click)="change_tap23(2)"
                                    data-toggle="tab">ยอดอ้อยตามรูทในโซน</a>
                            </li>
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary" href="#tab_3" (click)="change_tap23(3)"
                                    data-toggle="tab">ยอดอ้อยรายนสส ในแปลง</a>
                            </li>
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary" href="#tab_4" (click)="change_tap23(4)"
                                    data-toggle="tab">ประเมินใหม่31ม.ค. รายนสส</a>
                            </li>
                            <li class="nav-item">
                                <a class="btn btn-outline-secondary" href="#tab_4" (click)="change_tap23(5)"
                                    data-toggle="tab">ประเมินใหม่17ก.พ. รายนสส</a>
                            </li>
                            <!--<li class="nav-item"><a class="nav-link" href="#tab_3" data-toggle="tab">อ้อยคงเหลือ 15 ม.ค.</a></li>-->
                        </ul>
                    </div>
                    <div class="col-md-auto">
                        <mat-form-field appearance="fill">
                            <mat-label>ช่วงวันที่</mat-label>
                            <mat-date-range-input [rangePicker]="picker" disabled>
                                <input matStartDate [(ngModel)]="datein1.date1" placeholder="วันที่เริ่มต้น">
                                <input matEndDate [(ngModel)]="datein1.date2" placeholder="ถึงวันที่">
                            </mat-date-range-input>
                            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        </mat-form-field>
                    </div>
                    <div class="col-md-auto">
                        <button mat-raised-button *ngIf="texttap==0"
                            (click)="LoadCaneperdaybyzone();">ตกลง/Refresh</button>
                        <button mat-raised-button *ngIf="texttap==1||texttap==2"
                            (click)="LoadCaneperdaybygroup();">ตกลง/Refresh</button>
                        <button mat-raised-button *ngIf="texttap==3"
                            (click)="LoadCaneperdaybySV();">ตกลง/Refresh</button>
                        <button mat-raised-button *ngIf="texttap==4||texttap==5"
                            (click)="LoadCaneperdaybySV_n();">ตกลง/Refresh</button>
                    </div>
                </div>
                <mat-progress-bar *ngIf="loader[0]" mode="indeterminate"></mat-progress-bar>
            </mat-card-content>
        </mat-card>

        <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
                <div class="card">
                    <div class="card-header align-content-center">
                        <div style="float: left;">
                            <h2> <i class="fas fa-truck-moving"></i> {{textshow1}}</h2>
                        </div>
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn btn-outline-success" (click)="ExportExcel(1);"
                                    *ngIf="caneperdayzone.length >0"> <i class="far fa-file-excel"></i>
                                    Download </button>
                            </div>
                            <div class="col text-right">
                                <label>{{choosedate}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive p-0">
                        <table class="table table-hover table-head-fixed table-bordered border-primary" #table>
                            <thead>
                                <tr class="text-center align-middle">
                                    <!--
                                    <th [colSpan]="3"></th>
                                    <th [colSpan]="7"></th>
                                -->
                                    <th [rowSpan]="2">ส่วน</th>
                                    <th [rowSpan]="2">โซน</th>
                                    <th [rowSpan]="2">เป้าหมายอ้อย</th>

                                    <th [rowSpan]="2">ยืนยันเข้าหีบ</th>
                                    <th [rowSpan]="2">อ้อยสะสม</th>
                                    <th [rowSpan]="2">อ้อยคงเหลือ</th>
                                    <th [rowSpan]="2">ตัดพันธุ์</th>
                                    <th [rowSpan]="2">%สะสม</th>
                                    <th [rowSpan]="2">ccs สะสม</th>
                                    <th [rowSpan]="2">เป้า/วัน</th>

                                    <th [colSpan]="2" style="background: goldenrod;">{{(today)}}</th>

                                    <th [colSpan]="2" style="background: #65dd6f;"> อ้อยสด </th>
                                    <th [colSpan]="2" style="background: #fd6666;"> อ้อยไฟ </th>
                                    <th [rowSpan]="2">จำนวนแปลง</th>
                                    <th [colSpan]="5" style="background: #7d9bff;"> แปลงตัดเสร็จ </th>
                                    <th [colSpan]="2" style="background: skyblue;">ช่วงวันที่เลือก</th>
                                </tr>
                                <tr class="align-content-around" style="text-align:center">

                                    <th style="background: #d6bf84;">ตัน</th>
                                    <th style="background: #d6bf84;">%</th>

                                    <th style="background: #a0f3a4;">ตัน</th>
                                    <th style="background: #a0f3a4;">%</th>

                                    <th style="background: #fa9898;">ตัน</th>
                                    <th style="background: #fa9898;">%</th>

                                    <th style="background: #b2c3fc;">แปลง</th>
                                    <th style="background: #b2c3fc;">ประเมิน</th>
                                    <th style="background: #b2c3fc;">อ้อยเข้า</th>
                                    <th style="background: #b2c3fc;">ตัดพันธุ์</th>
                                    <th style="background: #b2c3fc;">%+-</th>

                                    <th style="background: #a8d5e7;">อ้อยเข้า </th>
                                    <th style="background: #a8d5e7;">CCS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of caneperdayzone" [ngClass]="{'table-secondary under' : item.zonename == null ,
                                        'table-success under':item.zonename == null && item.supzone == null}">
                                    <td>{{item.Partcode}}</td>
                                    <td>{{item.supzone}} {{item.zonename}}</td>
                                    <td style="text-align:right">{{item.canetarget | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.last_Assess | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canecollect | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.cane_left | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.Cutseed | number:'1.1-1'}}</td>
                                    <td style="text-align:right"
                                        [ngClass]="{'table-danger under' : item.pccanecollect <= topbardata[0] ,'table-success under':item.pccanecollect > topbardata[0] }">
                                        {{item.pccanecollect| number:'1.2-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.ccscollect | number:'1.1-2'}}</td>
                                    <!--
                                    <td style="text-align:right">{{item.cane_remain | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.caneinNow | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_now_left | number:'1.1-1'}}</td>
                                    -->

                                    <!--<td style="text-align:right">{{item.TonNow2 | number}}</td>-->
                                    <td style="text-align:right">{{item.caneperdate | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.canedate | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pccanedate | number:'1.1-2'}}</td>
                                    <td style="text-align:right">{{item.cane_type1 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type1 | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.cane_type2 | number:'1.1-2'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type2 | number:'1.0-2'}}</td>
                                    <td style="text-align:right">{{item.cnt_all | number}}</td>
                                    <td style="text-align:right">{{item.cnt_f | number}}</td>
                                    <td style="text-align:right">{{item.Assess_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.cutseedf | number:'1.1-1'}}</td>
                                    <td style="text-align:right" [ngClass]="{'table-danger under' : item.pc_canein_f <= 0 ,
                                            'table-success under': (item.pc_canein_f | number:'1.0-2') > 0 }">
                                        {{item.pc_canein_f | number:'1.0-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.canedaterang | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.ccsdaterang | number:'1.1-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- /.tab-pane -->
            <div class="tab-pane" id="tab_2">
                <div class="card">
                    <div class="card-header align-content-center">
                        <div style="float: left;">
                            <h2> <i class="fas fa-truck-moving"></i>{{textshow1}}</h2>
                        </div>
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn btn-outline-success" (click)="ExportExcel(2);"
                                    *ngIf="caneperdaygroup.length >0"> <i class="far fa-file-excel">
                                    </i> Download </button>
                            </div>
                            <div class="col text-right">
                                <label>{{choosedate}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive p-0">
                        <table class="table table-hover table-head-fixed table-bordered border-primary" #table2>
                            <thead>
                                <tr class="align-content-around" style="text-align:center">
                                    <th [rowSpan]="2">ส่วน</th>
                                    <th [rowSpan]="2">โซน</th>
                                    <th [rowSpan]="2">เป้าหมาย</th>
                                    <th [rowSpan]="2">อ้อยสะสม </th>
                                    <th [rowSpan]="2">ตัดพันธุ์ </th>
                                    <th [rowSpan]="2">%สะสม </th>
                                    <th [rowSpan]="2">อ้อยคงเหลือ </th>
                                    <th [rowSpan]="2">ccs สะสม</th>
                                    <!--<th colspan="3" style="background: rgba(252, 132, 226, 0.89);">ประเมินใหม่<br>
                                        ประเมิน | อ้อยเข้า | คงเหลือ</th>-->
                                    <th [rowSpan]="2">เป้า/วัน</th>
                                    <th colspan="2" style="background: goldenrod;">{{(today)}}</th>
                                    <th colspan="2" style="background: #7dff84;">อ้อยสด</th>
                                    <th colspan="2" style="background: #fc8383;">อ้อยไฟ</th>
                                    <th [rowSpan]="2">จำนวนแปลง</th>
                                    <th colspan="5" style="background: #7d9bff;"> ตัดเสร็จ</th>
                                    <th colspan="2" style="background: skyblue;">ช่วงวันที่เลือก</th>
                                </tr>
                                <tr class="align-content-around" style="text-align:center">

                                    <th style="background: #d6bf84;">ตัน</th>
                                    <th style="background: #d6bf84;">%</th>

                                    <th style="background: #a0f3a4;">ตัน</th>
                                    <th style="background: #a0f3a4;">%</th>

                                    <th style="background: #fa9898;">ตัน</th>
                                    <th style="background: #fa9898;">%</th>

                                    <th style="background: #b2c3fc;">แปลง</th>
                                    <th style="background: #b2c3fc;">ประเมิน</th>
                                    <th style="background: #b2c3fc;">อ้อยเข้า</th>
                                    <th style="background: #b2c3fc;">ตัดพันธุ์</th>
                                    <th style="background: #b2c3fc;">%+-</th>

                                    <th style="background: #a8d5e7;">อ้อยเข้า </th>
                                    <th style="background: #a8d5e7;">CCS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of caneperdaygroup" [ngClass]="{'table-secondary under' : item.zonename == null ,
                                        'table-success under':item.zonename == null && item.supzone == null}">
                                    <td>{{item.Partcode}}</td>
                                    <td>{{item.supzone}} {{item.zonename}}</td>
                                    <td style="text-align:right">{{item.canetarget | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canecollect_1601 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.Cutseed | number:'1.1-1'}}</td>
                                    <td style="text-align:right"
                                        [ngClass]="{'table-danger' : item.pccanecollect_1601 <= topbardata[1] ,'table-success': (item.pccanecollect_1601) > topbardata[1] }">
                                        {{item.pccanecollect_1601 | number:'1.2-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.cane_left| number:'1.1-1'}}</td>
                                    <!-- อ้อยคงเหลือทั้งหมด -->
                                    <td style="text-align:right">{{item.ccscollect | number:'1.1-2'}}</td>

                                    <!--
                                    <td style="text-align:right">{{item.cane_remain | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.caneinNow | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_now_left | number:'1.1-1'}}</td>
                                    -->
                                    <td style="text-align:right">{{item.caneperdate | number:'1.1-2'}}</td>
                                    <td style="text-align:right">{{item.canedate | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pccanedate | number:'1.0-2'}}</td>
                                    <td style="text-align:right">{{item.cane_type1 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type1 | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.cane_type2 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type2 | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.cnt_all | number}}</td>
                                    <td style="text-align:right">{{item.cnt_f | number}}</td>
                                    <td style="text-align:right">{{item.Assess_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.cutseedf | number:'1.1-1'}}</td>
                                    <td style="text-align:right" [ngClass]="{'table-danger' : item.pc_canein_f <= 0 ,
                                            'table-success':(item.pc_canein_f | number:'1.0-2') > 0 }">
                                        {{item.pc_canein_f | number:'1.0-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.canedaterang | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.ccsdaterang | number:'1.1-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="tab_3">
                <div class="card">
                    <div class="card-header align-content-center">
                        <div style="float: left;">
                            <h2> <i class="fas fa-truck-moving"></i>{{textshow1}}</h2>
                        </div>
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn btn-outline-success" (click)="ExportExcel(3);"
                                    *ngIf="caneperdaySV.length >0"> <i class="far fa-file-excel">
                                    </i> Download </button>
                            </div>
                            <div class="col text-right">
                                <label>{{choosedate}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive p-0">
                        <table class="table table-hover table-head-fixed table-bordered border-primary" #table3>
                            <thead>
                                <tr class="text-center align-middle">
                                    <th [rowSpan]="2">ส่วน</th>
                                    <th [rowSpan]="2">โซน</th>
                                    <th [rowSpan]="2">นสส</th>
                                    <th [rowSpan]="2">เป้าหมาย</th>
                                    <th [rowSpan]="2">ยืนยันเข้าหีบ</th>
                                    <th [rowSpan]="2">อ้อยเข้าสะสม </th>
                                    <th [rowSpan]="2">ตัดพันธุ์ </th>
                                    <th [rowSpan]="2">% อ้อยสะสม </th>
                                    <th [rowSpan]="2">อ้อยคงเหลือ</th>
                                    <th [rowSpan]="2">ccs สะสม</th>
                                    <th [rowSpan]="2">เป้า/วัน</th>
                                    <th colspan="2" style="background: goldenrod;">{{(today)}}</th>
                                    <th colspan="2" style="background: #80ff86;">อ้อยสด</th>
                                    <th colspan="2" style="background: #fc8383;">อ้อยไฟ</th>
                                    <th [rowSpan]="2">จำนวนแปลง</th>
                                    <th colspan="6" style="background: #7d9bff;"> ตัดเสร็จ</th>
                                    <th colspan="2" style="background: skyblue;">ช่วงวันที่เลือก</th>
                                </tr>
                                <tr class="align-content-around" style="text-align:center">

                                    <th style="background: #d6bf84;">ตัน</th>
                                    <th style="background: #d6bf84;">%</th>

                                    <th style="background: #a0f3a4;">ตัน</th>
                                    <th style="background: #a0f3a4;">%</th>

                                    <th style="background: #fa9898;">ตัน</th>
                                    <th style="background: #fa9898;">%</th>

                                    <th style="background: #b2c3fc;">แปลง</th>
                                    <th style="background: #b2c3fc;">ประเมิน</th>
                                    <th style="background: #b2c3fc;">อ้อยเข้า</th>
                                    <th style="background: #b2c3fc;">ตัดพันธุ์</th>
                                    <th style="background: #b2c3fc;">เทียบ%</th>
                                    <th style="background: #b2c3fc;">%+-</th>

                                    <th style="background: #a8d5e7;">อ้อยเข้า </th>
                                    <th style="background: #a8d5e7;">CCS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of caneperdaySV" [ngClass]="{'table-danger under' : item.Partcode == 'BRD' 
                                ,'table-success under' : item.supzone == 'sumP' 
                                ,'table-secondary under' : item.SUPCODE == 'sumS'}">
                                    <td>{{item.Partcode}}</td>
                                    <td>{{item.supzone}}</td>
                                    <td>{{item.SUPCODE}} {{item.SUPNAME}}</td>
                                    <td style="text-align:right">{{item.canetarget | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.last_Assess | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canecollect | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.Cutseed | number:'1.1-1'}}</td>
                                    <td style="text-align:right"
                                        [ngClass]="{'table-danger' : item.pccanecollect <= topbardata[3] ,'table-success': (item.pccanecollect) > topbardata[3] }">
                                        {{item.pccanecollect | number:'1.2-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.cane_left| number:'1.1-1'}}</td>
                                    <!-- อ้อยคงเหลือทั้งหมด -->
                                    <td style="text-align:right">{{item.ccscollect | number:'1.1-2'}}</td>
                                    <!--
                                    <td style="text-align:right">{{item.cane_remain | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.caneinNow | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_now_left | number:'1.1-1'}}</td>
                                    -->
                                    <td style="text-align:right">{{item.caneperdate | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canedate | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pccanedate | number:'1.0-2'}}</td>
                                    <td style="text-align:right">{{item.cane_type1 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type1 | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.cane_type2 | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.pc_cane_type2 | number:'1.0-1'}}</td>
                                    <td style="text-align:right">{{item.cnt_all | number}}</td>
                                    <td style="text-align:right">{{item.cnt_f | number}}</td>
                                    <td style="text-align:right">{{item.Assess_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.cutseedf | number:'1.1-1'}}</td>
                                    <td style="text-align:right" [ngClass]="{'table-danger' : item.pcCompare <= 70 ,
                                            'table-success':(item.pcCompare | number:'1.0-1') > 70 }">
                                        {{item.pcCompare | number:'1.0-1'}}</td>
                                    <td style="text-align:right" [ngClass]="{'table-danger' : item.pc_canein_f <= 0 ,
                                            'table-success':(item.pc_canein_f | number:'1.0-2') > 0 }">
                                        {{item.pc_canein_f | number:'1.0-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.canedaterang | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.ccsdaterang | number:'1.1-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="tab-pane" id="tab_4">
                <div class="card">
                    <div class="card-header align-content-center">
                        <div style="float: left;">
                            <h2> <i class="fas fa-truck-moving"></i>{{textshow1}}</h2>
                        </div>
                        <div class="row">
                            <div class="col text-left">
                                <button class="btn btn-outline-success" (click)="ExportExcel(3);"
                                    *ngIf="caneperdaySV.length >0"> <i class="far fa-file-excel">
                                    </i> Download </button>
                            </div>
                            <div class="col text-right">
                                <label>{{choosedate}}</label>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive p-0">
                        <table class="table table-hover table-head-fixed table-bordered border-primary" #table4>
                            <thead class="text-center">
                                <tr class="text-center align-middle">
                                    <th [colSpan]="4"></th>
                                    <th [colSpan]="5" style="background: #a3e477;"> ประเมินใหม่ </th>
                                    <th [colSpan]="7" style="background: #7d9bff;"> แปลงตัดเสร็จ </th>
                                    <th [colSpan]="2" style="background: skyblue;"> ช่วงวันที่เลือก </th>
                                </tr>
                                <tr class="text-center align-middle">
                                    <th>ส่วน</th>
                                    <th>โซน</th>
                                    <th>นสส</th>
                                    <th>เป้าหมาย</th>

                                    <th style="background: #c4f7a2;">ยืนยันเข้าหีบ</th>
                                    <th style="background: #c4f7a2;">อ้อยเข้า </th>
                                    <th style="background: #c4f7a2;">%สะสม </th>
                                    <th style="background: #c4f7a2;">คงเหลือ</th>
                                    <th style="background: #c4f7a2;">แปลง</th>

                                    <th style="background: #bfccf3;">แปลง</th>
                                    <th style="background: #bfccf3;">พื้นที่</th>
                                    <th style="background: #bfccf3;">ประเมิน</th>
                                    <th style="background: #bfccf3;">อ้อยเข้า</th>
                                    <th style="background: #bfccf3;">ตัน+-</th>
                                    <th style="background: #bfccf3;">%+-</th>
                                    <th style="background: #bfccf3;">%ตัดเสร็จ</th>

                                    <th style="background: #a8d5e7;">อ้อยเข้า </th>
                                    <th style="background: #a8d5e7;">CCS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of caneperdaygroup_n" [ngClass]="{'table-danger under' : item.Partcode == 'BRD' 
                                ,'table-success under' : item.supzone == 'sumP' 
                                ,'table-secondary under' : item.SUPCODE == 'sumS'}">
                                    <td>{{item.Partcode}}</td>
                                    <td>{{item.supzone}}</td>
                                    <td>{{item.SUPCODE}} {{item.SUPNAME}}</td>
                                    <td style="text-align:right">{{item.canetarget | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.new_assess | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.caneinNow | number:'1.1-1'}}</td>
                                    <td style="text-align:right"
                                        [ngClass]="{'table-danger' : item.pccanecollect <= topbardata1[0] ,'table-success': (item.pccanecollect) > topbardata1[0] }">
                                        {{item.pccanecollect | number:'1.2-2'}}
                                    </td>
                                    <td style="text-align:right">{{item.cane_left| number:'1.1-1'}}</td>
                                    <!-- อ้อยคงเหลือทั้งหมด -->
                                    <td style="text-align:right">{{item.cnt_all | number}}</td>
                                    <td style="text-align:right">{{item.cnt_f | number}}</td>
                                    <td style="text-align:right">{{item.landvalue_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.Assess_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.canein_f | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.tonCompare | number:'1.1-1'}}</td>
                                    <td style="text-align:right" [ngClass]="{'table-danger' : item.pc_canein_f <= 0 ,
                                            'table-success':item.pc_canein_f > 0 }">
                                        {{item.pc_canein_f | number:'1.0-2'}}
                                    </td>
                                    <td style="text-align:right" [ngClass]="{'table-danger' : item.pc_cut_f < 80 ,
                                            'table-success':item.pc_cut_f >= 80 }">
                                        {{item.pc_cut_f | number:'1.0-2'}}
                                    </td>

                                    <td style="text-align:right">{{item.canedaterang | number:'1.1-1'}}</td>
                                    <td style="text-align:right">{{item.ccsdaterang | number:'1.1-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div><!-- /.card-body -->
    </div>
    <!-- ./card -->
</div>
<app-footer></app-footer>